export function useLoginPage() {
  const appStore = useAppStore();
  const { ROSA_PLATFORM } = storeToRefs(appStore);

  return ROSA_PLATFORM.value?.includes('guian') ? '/login-guian' : '/login';
}
